import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (uuid) => {
	return fetch(Methods.GET, EndPoints.PUBLIC_OFFER.replace(':uuid', uuid), null, null, false);
};
